/**
 * Adapts a host's i18next instance to `FormsI18n`. Wix Forms types its `i18n` against
 * `@wix/fe-essentials`' i18next; the hosts get theirs from their flow's own fe-essentials flavour.
 * Same runtime object, so this is the one place the two declarations meet.
 */
export const toFormsI18n = (i18n) => i18n;
export const EMPTY_PRELOADED_FORMS = Object.freeze({ forms: {} });
/** One form out of a `PreloadedForms` batch, joined with the shared locale resources. */
export const getPreloadedForm = (preloaded, formId) => {
    const fetched = preloaded?.forms[formId];
    return fetched
        ? {
            ...fetched,
            translations: preloaded?.translations,
            localeDataset: preloaded?.localeDataset,
        }
        : undefined;
};
//# sourceMappingURL=types.js.map